export default __webpack_public_path__ + "src/shared/svg/providers/736bcde11b7d20a8dfb459bb0d13fda4.png";